module.exports = __webpack_public_path__ + "img/slw.351c26f7.jpg";